__turbopack_context__.v({
  "fitContain": "ProductImage-module__MrK7PG__fitContain",
  "root": "ProductImage-module__MrK7PG__root",
});
